export default __webpack_public_path__ + "static/media/icon-02.33beb7d9.svg";